import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { useMsal } from "../context/MsalContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { handleAuthCallback } = useMsal();
  const [status, setStatus] = useState("processing"); // processing, success, error
  const [error, setError] = useState(null);

  useEffect(() => {
    const hash = window.location.hash;
    
    if (hash) {
      const result = handleAuthCallback(hash);
      
      if (result.success) {
        setStatus("success");
        // Redirect after a brief delay
        setTimeout(() => {
          navigate("/data-source");
        }, 1500);
      } else {
        setStatus("error");
        setError(result.error);
      }
    } else {
      setStatus("error");
      setError("No authentication response received");
    }
  }, [handleAuthCallback, navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback-page">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6">
          <div className="text-center">
            {status === "processing" && (
              <>
                <Loader2 className="w-12 h-12 text-primary mx-auto mb-4 animate-spin" />
                <h2 className="text-xl font-semibold text-foreground mb-2">Connecting...</h2>
                <p className="text-muted-foreground">Please wait while we complete the authentication</p>
              </>
            )}
            
            {status === "success" && (
              <>
                <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto mb-4" />
                <h2 className="text-xl font-semibold text-foreground mb-2">Connected Successfully!</h2>
                <p className="text-muted-foreground">Redirecting to Data Source...</p>
              </>
            )}
            
            {status === "error" && (
              <>
                <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
                <h2 className="text-xl font-semibold text-foreground mb-2">Connection Failed</h2>
                <p className="text-muted-foreground mb-4">{error || "An error occurred during authentication"}</p>
                <Button onClick={() => navigate("/data-source")} data-testid="back-btn">
                  Go Back
                </Button>
              </>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
